import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterData: {
    date: null,
    day_interval: {
      label: 'Ежеминутно',
      value: 60,
      id: 2,
    },
    dep: null,
    car: null,
    type: null,
  },
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilterData(state, action) {
      const { payload } = action;
      state.filterData = payload;
    },
    clearFilterData(state) {
      state.filterData = initialState.filterData;
    },
  },
});

export const { setFilterData, clearFilterData } = filterSlice.actions;
export default filterSlice.reducer;
